import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './widget.css';
import { ChatContainer } from './Components/ChatContainer';
import { isAvatarType } from './Constants';

const root = document.getElementById('chatbot-root');
if (root) {
    const rawAvatarType = root.dataset.avatarType;
    const avatarType = rawAvatarType && isAvatarType(rawAvatarType) ? rawAvatarType : undefined;

    createRoot(root).render(
        <StrictMode>
            <ChatContainer
                primaryColor={root.dataset.primaryColor}
                textColor={root.dataset.textColor}
                siteName={root.dataset.siteName ?? ''}
                assistantName={root.dataset.assistantName}
                avatarType={avatarType}
                avatarImageUrl={root.dataset.avatarImageUrl}
            />
        </StrictMode>,
    );
}
